import React from "react";

import { useTheme } from "@mui/material";
import propTypes from "prop-types";

import CurrencyAmount from "./CurrencyAmount";

const Price = ({ value, compact = false }) => {
  const theme = useTheme();

  return (
    <CurrencyAmount
      value={value}
      iconSize={compact ? "0.76em" : "0.72em"}
      sx={{
        color: theme.palette.primary.main,
        fontSize: compact ? "1.75rem" : "2.2rem",
        fontWeight: theme.typography.fontWeightBold,
      }}
    />
  );
};

Price.propTypes = {
  value: propTypes.number.isRequired,
  compact: propTypes.bool,
};

export default Price;
